import { http } from 'connex-cds';

export default {
  listTraces: ({ entityRef, queryParams }) =>
    http.get({ apiName: 'dexa', path: `/${entityRef}/traces`, queryParams }),
  createTraces: ({ entityRef, data }) => http.post({ apiName: 'dexa', path: `/${entityRef}/traces`, data }),
  updateTraces: ({ entityRef, mixRef, data }) =>
    http.patch({ apiName: 'dexa', path: `/${entityRef}/traces/${mixRef}`, data }),
};
